module.exports = __webpack_public_path__ + "img/1745-1747.a8646cf7.jpg";